import { WebCodeSend, updateInvitationRelation, FeatureCheck, getUserDetail } from '@/apis/modules/uc'
import { tencentCaptchaService } from '@/utils/TCaptchaService'
import { Toast } from 'vant'
import { i18n } from '@/i18n/login'

const state = () => ({
    path: '', // 登录成功之后需要跳转的页面, 默认跳转开户
    openType: '', // 打开方式，默认：href  || open
    salt: '',
    phone: '',
    areaCode: '',
})

const getters = {
    getPhoneAndAreaCode(state) {
        return {
            phone: state.phone,
            areaCode: state.areaCode,
        }
    },
    getFullPhone(state) {
        return `${state.areaCode}${state.phone}`
    },
    getParamet(state) {
        return {
            path: state.path,
            type: state.openType,
        }
    },
}

const mutations = {
    setParamet(state, data) {
        state.path = data.path || `./openAccount.html?langType=${data.langType}`
        state.openType = data.type || 'href'
    },
    setPhoneAndAreaCode(state, { phone, areaCode }) {
        state.phone = phone ?? ''
        state.areaCode = areaCode ?? ''
    },

    setSalt(state, salt) {
        state.salt = salt ?? ''
    },

    setRedirectInfo(state, { type }) {
        if (type) {
            state.redirectType = type
        }
    },
}

const actions = {
    upParamet({ commit }, data) {
        commit('setParamet', data)
    },
    updatePhoneAndAreaCode({ commit }, data) {
        commit('setPhoneAndAreaCode', data)
    },
    updateSalt({ commit }, salt) {
        commit('setSalt', salt)
    },
    updateRedirectInfo({ commit }, data) {
        commit('setRedirectInfo', data)
    },

    async sendCode({ commit }, { scene = 10, type = 1, value = '', areaCode = '', captcha } = {}) {
        try {
            Toast.loading({
                duration: 15000,
                message: i18n.t('requestCode.jzz'),
            })

            const res = await WebCodeSend({
                scene, // 验证码登录
                type, // 手机登录
                value,
                areaCode,
                captcha,
            })
            Toast.clear()

            const data = res?.data
            const salt = localStorage.getItem('salt')
            if (data?.result) {
                commit('setSalt', data?.result?.salt)
                localStorage.setItem('salt', data?.result?.salt)
            } else if (data?.error?.code == 110112) {
                //60s内重复发送，取上一次的盐
                salt && commit('setSalt', salt)
            } else {
                Toast(i18n.t('loginPage.yzmfssb'))
            }
            return data
        } catch (err) {
            console.log('🚀 ~ sendCode ~ err', err)
            Toast.clear()
            Toast(i18n.t('requestCode.fwqzwxyqshzs'))

            return {}
        }
    },
    async tencentCaptcha() {
        return new Promise((res, rej) => {
            const tencentCaptcha = tencentCaptchaService(({ ret, ticket, randstr, ...otherParameters }) => {
                if (ret === 0) {
                    res(`${ticket} ${randstr}`)
                } else {
                    rej({ ret, ...otherParameters })
                }
            })
            tencentCaptcha.show()
        })
    },
    // 异步更新邀请关系，等待结果
    async updateInvitationRelationAsync({ commit }, { stage, inviteCode, requestUserDetail = false }) {
        // 校验 inviteCode 是否存在且有效
        if (typeof inviteCode !== 'string' || inviteCode.trim() === '') {
            console.log('updateInvitationRelationAsync:', 'inviteCode is invalid or empty')
            return
        }

        try {
            let result = null

            // 根据 requestUserDetail 参数决定是否请求用户详情
            if (requestUserDetail) {
                const { data } = await getUserDetail()
                result = data?.result

                if (result) {
                    console.log('✅ 成功获取用户详细信息:', result)
                    // 将完整的用户信息存储到 localStorage
                    localStorage.setItem('userInfo', JSON.stringify(result))
                    console.log('✅ 用户信息已存储到 localStorage')
                }
            } else {
                // 不请求用户详情，直接使用 localStorage 中的用户信息
                const userInfoStr = localStorage.getItem('userInfo')
                if (userInfoStr) {
                    try {
                        result = JSON.parse(userInfoStr)
                        console.log('✅ 使用 localStorage 中的用户信息:', result)
                    } catch (e) {
                        console.warn('解析 localStorage 中的用户信息失败:', e)
                    }
                }
            }

            if (result) {
                // 先检查功能开关
                const { data: featureData } = await FeatureCheck({ features: ['Invitation'] })
                const isInvitationAllow = featureData?.result?.Invitation?.allow
                console.log('FeatureCheck:', featureData)

                // 如果功能开关允许，则更新邀请关系
                if (isInvitationAllow === true) {
                    const { data: invitationData } = await updateInvitationRelation({ stage: stage, code: inviteCode })
                    console.log('邀请关系更新成功:', inviteCode, JSON.stringify(invitationData))
                    return invitationData
                }
                console.log('邀请功能未开启，跳过邀请关系更新')
            } else {
                console.log('未获取到用户信息，跳过邀请关系更新')
            }

            return null
        } catch (error) {
            console.error('邀请关系更新失败:', inviteCode, JSON.stringify(error))
            // 不抛出错误，避免影响主流程
            return null
        }
    },
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
